import React from 'react';

import FieldText from '../common/FieldText';
import FieldDate from '../common/FieldDate';
import FieldDateTime from '../common/FieldDateTime';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldToggle from '../common/FieldToggle';

class LeadAddEditInfo extends React.Component {
  render() {
    const fields = this.props.model.fields;
    const lead = this.props.lead;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    return (
      <>
        <div className="formhead col-md-12"><h2>Information</h2></div>
        
        <FieldText key="firstname" id="firstname" field={fields.firstname}
          value={lead.firstname} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="middlename" id="middlename" field={fields.middlename}
          value={lead.middlename} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="lastname" id="lastname" field={fields.lastname}
          value={lead.lastname} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="gender" id="gender" field={fields.gender}
          value={lead.gender} onValueChange={onValueChange} inValid={inValid} />

        <FieldDate key="dob" id="dob" field={fields.dob}
          value={lead.dob} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="progress" id="progress" field={fields.progress}
          value={lead.progress} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="company_name" id="company_name" field={fields.company_name}
          value={lead.company_name} onValueChange={onValueChange} inValid={inValid} />

        <FieldDate key="anniversary" id="anniversary" field={fields.anniversary}
          value={lead.anniversary} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="industry" id="industry" field={fields.industry}
          value={lead.industry} onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiSelect key="responsible_person" id="responsible_person"
          field={fields.responsible_person} value={lead.responsible_person}
          onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiSelect key="interested_product" id="interested_product"
          field={fields.interested_product} value={lead.interested_product}
          onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="source" id="source" field={fields.source}
          value={lead.source} onValueChange={onValueChange} inValid={inValid} />

        <FieldDateTime key="enquiry_date" id="enquiry_date" field={fields.enquiry_date}
          value={lead.enquiry_date} onValueChange={onValueChange} inValid={inValid} />

        <FieldToggle key="email_opt" id="email_opt" field={fields.email_opt}
          value={lead.email_opt} onValueChange={onValueChange} inValid={inValid} />

        <FieldToggle key="sms_opt" id="sms_opt" field={fields.sms_opt}
          value={lead.sms_opt} onValueChange={onValueChange} inValid={inValid} />
      </>
    );
  }
}

export default LeadAddEditInfo;